import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden" }
const _hoisted_3 = { class: "border-b dark:border-gray-700 mx-4" }
const _hoisted_4 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3" }
const _hoisted_5 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }
const _hoisted_6 = { class: "w-full md:max-w-sm flex-1 md:mr-4" }
const _hoisted_7 = { class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "mt-6 grid gap-6 md:grid-cols-2" }
const _hoisted_10 = { class: "md:col-span-2" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "overflow-x-auto" }
const _hoisted_13 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "border-b dark:border-gray-600" }
const _hoisted_17 = {
  class: "px-4 py-4 text-sm text-gray-500",
  colspan: "4"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  class: "px-4 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white",
  scope: "row"
}
const _hoisted_20 = { class: "px-4 py-3" }
const _hoisted_21 = { class: "px-4 py-3 whitespace-nowrap" }
const _hoisted_22 = { class: "px-4 py-3 whitespace-nowrap" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  "aria-label": "Table navigation",
  class: "flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
}
const _hoisted_26 = { class: "text-sm font-normal text-gray-500 dark:text-gray-400" }
const _hoisted_27 = { class: "font-semibold text-gray-900 dark:text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center justify-between space-x-4 pt-3" }, [
          _createElementVNode("div", { class: "flex-1 flex items-center space-x-3" }, [
            _createElementVNode("h5", { class: "dark:text-white font-semibold" }, " Announcements ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                class: "text-sm font-medium text-gray-900 sr-only dark:text-white",
                for: "announcement-search"
              }, "Search", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "announcement-search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                class: "block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                placeholder: "Search announcements...",
                type: "search"
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('newAnnouncement')))
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "h-3.5 w-3.5 mr-2",
                fill: "none",
                height: "12",
                viewBox: "0 0 12 12",
                width: "12",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M6 0.75V11.25M0.75 6H11.25",
                  stroke: "white",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                })
              ], -1),
              _createTextVNode(" Add New Announcement ")
            ])),
            _createVNode(_component_Modal, {
              "is-visible": _ctx.modals.newAnnouncement,
              "modal-id": "newAnnouncement",
              "onUpdate:isVisible": _cache[6] || (_cache[6] = value => _ctx.modals.newAnnouncement = value)
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                    _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800" }, " Add New Announcement "),
                    _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, " Publish a new message to members. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Title", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "Announcement title",
                        required: "",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Message", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.body) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "Write the announcement",
                        rows: "3",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.form.body]
                      ])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('newAnnouncement')))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createAnnouncement && _ctx.createAnnouncement(...args)))
                  }, " Publish ")
                ])
              ]),
              _: 1
            }, 8, ["is-visible"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Title "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Message "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Created "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, [
                _createElementVNode("span", { class: "sr-only" }, "Actions")
              ])
            ])
          ], -1)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, _cache[13] || (_cache[13] = [
                _createElementVNode("tr", { class: "border-b dark:border-gray-600" }, [
                  _createElementVNode("td", {
                    class: "px-4 py-4 text-sm text-gray-500",
                    colspan: "4"
                  }, " Loading announcements... ")
                ], -1)
              ])))
            : (_ctx.filteredAnnouncements.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                  _createElementVNode("tr", _hoisted_16, [
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.searchQuery ? 'No announcements match your search.' : 'No announcements yet.'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAnnouncements, (announcement) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: announcement._id,
                      class: "border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                    }, [
                      _createElementVNode("th", _hoisted_19, _toDisplayString(announcement.title), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(announcement.body), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatDate(announcement.createdAt)), 1),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            class: "flex items-center justify-center w-10 h-10 text-gray-700 bg-white border border-gray-300 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            to: `/administrator/announcements/${announcement._id}`,
                            "aria-label": "Edit announcement",
                            title: "Edit"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("g", null, [
                                    _createElementVNode("g", null, [
                                      _createElementVNode("g", null, [
                                        _createElementVNode("g", null, [
                                          _createElementVNode("g", null, [
                                            _createElementVNode("path", {
                                              d: "M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8",
                                              fill: "none",
                                              stroke: "#000000",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            }),
                                            _createElementVNode("polygon", {
                                              fill: "none",
                                              points: "12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8",
                                              stroke: "#000000",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            })
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ], -1)
                            ])),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("button", {
                            class: "flex items-center justify-center w-10 h-10 text-red-500 bg-white border border-red-400 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-red-600 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            type: "button",
                            "aria-label": "Delete announcement",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.deleteAnnouncement(announcement._id))
                          }, _cache[15] || (_cache[15] = [
                            _createStaticVNode("<svg class=\"w-5 h-5\" fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M4 7H20\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></g></svg>", 1)
                          ]), 8, _hoisted_24)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createElementVNode("nav", _hoisted_25, [
        _createElementVNode("span", _hoisted_26, [
          _cache[17] || (_cache[17] = _createTextVNode(" Showing ")),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "1-10", -1)),
          _cache[19] || (_cache[19] = _createTextVNode(" of ")),
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.filteredAnnouncements.length), 1)
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("ul", { class: "inline-flex items-stretch -space-x-px" }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Previous"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "0")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              "aria-current": "page",
              class: "flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "...")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Next"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ])
        ], -1))
      ])
    ])
  ]))
}